import {
  Action,
  ActionType,
  IGetActivityFilterListResponse,
} from "models/messagemanagement/activityFilterList";
import createReducer from "../../createReducer";

export interface ActivityFilterListReducerType {
  loading: boolean;
  error?: string;
  activityFilterResponse?: IGetActivityFilterListResponse;
}

const defaultState: ActivityFilterListReducerType = {
  loading: false,
  error: undefined,
  activityFilterResponse: undefined,
};

export const activityListFilterReducer =
  createReducer<ActivityFilterListReducerType>(defaultState, {
    [ActionType.ACTIVITY_FILTER_LIST](state: ActivityFilterListReducerType) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.ACTIVITY_FILTER_ERROR](
      state: ActivityFilterListReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [ActionType.ACTIVITY_FILTER_SUCCESS](
      state: ActivityFilterListReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        activityFilterResponse: action.payload,
      };
    },
  });
